import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { ChakraProvider } from "@chakra-ui/react";
import customTheme from "./utils/theme";
import store from "./store";
import { GoogleOAuthProvider } from "@react-oauth/google";

import "@fontsource/inter/400.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/800.css";

if (
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_DISABLE_DEV_OVERLAY === "true"
) {
  const resizeObserverError =
    "ResizeObserver loop completed with undelivered notifications.";

  const hideDevServerOverlay = () => {
    const overlay = document.getElementById("webpack-dev-server-client-overlay");
    if (!overlay) {
      return;
    }

    overlay.style.setProperty("display", "none", "important");
    overlay.style.setProperty("visibility", "hidden", "important");
    overlay.style.setProperty("pointer-events", "none", "important");
  };

  const overlayStyle = document.createElement("style");
  overlayStyle.textContent = `
    #webpack-dev-server-client-overlay {
      display: none !important;
      visibility: hidden !important;
      pointer-events: none !important;
    }
  `;
  document.head.appendChild(overlayStyle);
  hideDevServerOverlay();

  new MutationObserver(() => {
    hideDevServerOverlay();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // React's dev overlay treats this browser-only ResizeObserver warning as a
  // fatal runtime error and blocks the UI during E2E runs.
  window.addEventListener(
    "error",
    (event) => {
      if (event.message?.includes(resizeObserverError)) {
        hideDevServerOverlay();
        event.stopImmediatePropagation();
      }
    },
    true
  );
}

ReactDOM.render(
  <Provider store={store}>
    <ChakraProvider theme={customTheme}>
      <GoogleOAuthProvider
        clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </GoogleOAuthProvider>
    </ChakraProvider>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
